import { TabValues } from "../deliveryModalUtils/const-enums-types";
/**
 * This function determines if the selected address is a new selection or not.
 * @param newAddressData
 * @param initTabProps
 * @param setNewAddressSelected
 */
export const updateSelectedState = (newAddressData, initTabProps, setNewAddressSelected) => {
    if (!newAddressData) {
        setNewAddressSelected(false); // No new address data, no selection made
        return;
    }
    const isInitialPickup = initTabProps.initTabValue === TabValues.PICKUP;
    const isInitialDelivery = initTabProps.initTabValue === TabValues.DELIVERY;
    const isNewPickupLocation = !!newAddressData.location_sku;
    const isNewDeliveryLocation = !!newAddressData.address_id;
    if ((isNewPickupLocation && isInitialDelivery) || (isNewDeliveryLocation && isInitialPickup)) {
        setNewAddressSelected(true); // New selection made from pickup to delivery or vice versa
        return;
    }
    // Check if the initial values and new values match
    const initLocationOrDeliveryMatch = initTabProps.initPickupLocation === newAddressData.location_sku ||
        Number(initTabProps.initDeliveryLocation) === Number(newAddressData.address_id);
    if (initLocationOrDeliveryMatch) {
        setNewAddressSelected(false); // Initial and new values match, no new selection made
        return;
    }
    // No match found, new selection made
    setNewAddressSelected(true);
};
